export class OrderTurnaroundNotFoundError extends Error {
  constructor() {
    super('The turnaround chosen for this order is no longer available. Please choose another one to continue.')
    Object.setPrototypeOf(this, OrderTurnaroundNotFoundError.prototype)
  }
}
